let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("dsiAd"), load("7Lxlr")]).then(() => parcelRequire('kl4T5'));